import React from "react";
import "../styles/FloatingButton.css";

// Import icons
import phoneIcon from "../assets/call.png";
import whatsappIcon from "../assets/social.png";

const FloatingButton = () => {
  return (
    <div className="floating-buttons">
      {/* WhatsApp Button - Right Side */}
      <a
        href="https://wa.me/917428203483"
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn whatsapp-btn"
      >
        <div className="btn-pulse whatsapp-pulse"></div>
        <div className="btn-ring"></div>
        <img src={whatsappIcon} alt="WhatsApp" />
        <span className="btn-tooltip">Chat with us on WhatsApp!</span>
      </a>

      {/* Call Button - Left Side */}
      <a
        href="tel:+917428203483"
        className="float-btn call-btn"
      >
        <div className="btn-pulse call-pulse"></div>
        <div className="btn-ring"></div>
        <img src={phoneIcon} alt="Call Now" />
        <span className="btn-text">Call Now</span>
        <span className="btn-tooltip">Call us now for Enquiry!</span>
      </a>
    </div>
  );
};

export default FloatingButton;